export default "__VITE_ASSET__ec0d15e9__"